var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('vue-headful',{attrs:{"title":"ePlato Дати іспитів"}}),_c('v-layout',{staticStyle:{"display":"block"}},[_c('admin-exam-settings-dates-index')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }